import { Link } from "react-router-dom";

export interface Crumb {
  name: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
      <Link to="/" className="hover:text-primary-700 transition-colors flex items-center gap-1">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.name}-${index}`} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.path && !isLast ? (
              <Link to={item.path} className="hover:text-primary-700 transition-colors">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.name}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}